module.exports = __webpack_public_path__ + "save.png?f5647ae9c6bdd5e9b874a4a9434dee97";


//////////////////
// WEBPACK FOOTER
// ./src/images/save.png
// module id = 397
// module chunks = 0